document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cross-sell__atc[data-variant-id]');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId || btn.dataset.available === 'false') return;

  btn.classList.add('is-loading');
  const originalText = btn.textContent.trim();
  btn.textContent = 'Aggiungendo…';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (!res.ok) throw new Error('Cart error');

    document.dispatchEvent(new CustomEvent('cart:refresh'));

    const cartCountEl = document.querySelector('.cart-count-bubble span:first-child');
    if (cartCountEl) {
      const countRes = await fetch('/cart.js');
      const cart = await countRes.json();
      cartCountEl.textContent = cart.item_count;
    }

    btn.textContent = '✓ Aggiunto';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.classList.remove('is-loading');
    }, 2000);

  } catch {
    btn.textContent = 'Riprova';
    btn.classList.remove('is-loading');
    setTimeout(() => { btn.textContent = originalText; }, 2000);
  }
});